module.exports = __webpack_public_path__ + "img/rosepetal-dep-bredenoord.416975d3.jpg";